package com.anjuros.website.templates.selection.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.selection.modules.FAQ
import com.anjuros.website.templates.selection.modules.Theme
import com.anjuros.website.templates.selection.util.Constants
import com.anjuros.website.templates.selection.util.Res
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.TransitionTimingFunction
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.pointerEvents
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.CSSColorValue
import org.jetbrains.compose.web.css.Color
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.rgba
import org.jetbrains.compose.web.css.times
import org.jetbrains.compose.web.dom.A
import org.jetbrains.compose.web.dom.B
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.I
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Span
import org.jetbrains.compose.web.dom.Text

@Composable
fun RichText(
    text: String,
    linkColor: CSSColorValue = Theme.ShowcaseButton.rgb
) {
    // Regex matches: {b}...{/b} OR {i}...{/i} OR <a href="...">...</a>
    val regex = """\{b\}(.*?)\{/b\}|\{i\}(.*?)\{/i\}|<a\s+href="([^"]+)">(.*?)</a>""".toRegex()
    var lastIndex = 0

    Span {
        regex.findAll(text).forEach { matchResult ->
            val range = matchResult.range

            if (range.first > lastIndex) {
                SpanText(text.substring(lastIndex, range.first))
            }

            when {
                // Group 1: {b}text{/b}
                matchResult.groups[1] != null -> {
                    B {
                        SpanText(matchResult.groups[1]!!.value)
                    }
                }

                // Group 2: {i}text{/i}
                matchResult.groups[2] != null -> {
                    I {
                        SpanText(matchResult.groups[2]!!.value)
                    }
                }

                // Group 3 & 4: <a href="...">text</a>
                matchResult.groups[3] != null -> {
                    val href = matchResult.groups[3]!!.value
                    val linkText = matchResult.groups[4]!!.value

                    Link(
                        modifier = Modifier
                            .textDecorationLine(TextDecorationLine.Underline)
                            .color(linkColor)
                            .fontWeight(FontWeight.Bold),
                        path = href
                    ) {
                        Text(linkText)
                    }
                }
            }

            lastIndex = range.last + 1
        }

        if (lastIndex < text.length) {
            SpanText(text.substring(lastIndex))
        }
    }
}
